<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-btn variant="text" v-bind="props" class="language-btn" :min-width="isMobile ? '40' : 'auto'">
        <v-avatar size="24" :class="isMobile ? '' : 'mr-2'">
          <img :src="currentFlag" :alt="currentLanguageName" />
        </v-avatar>
        <span class="d-none d-sm-inline">{{ currentLanguageName }}</span>
        <v-icon right v-if="!isMobile">keyboard_arrow_down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item
        v-for="lang in languages"
        :key="lang.code"
        @click="changeLanguage(lang.code)"
        class="cursor-pointer"
        :active="lang.code === currentLocale"
      >
        <template #prepend>
          <v-avatar size="26">
            <img
              :class="lang.code === 'tr' ? 'turkish-flag-style' : ''"
              :src="lang.flag"
              :alt="lang.name"
            />
          </v-avatar>
        </template>
        <v-list-item-title>{{ lang.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script setup>
 import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';

const { locale } = useI18n();
const { mobile: isMobile } = useDisplay();

const languages = [
  { code: 'sq', name: 'Albanian', flag: 'https://flagcdn.com/w40/al.png' },
  { code: 'en', name: 'English', flag: 'https://flagcdn.com/w40/us.png' },
  { code: 'tr', name: 'Turkish', flag: 'https://flagcdn.com/w40/tr.png' },
  { code: 'ar', name: 'Arabic', flag: 'https://flagcdn.com/w40/sa.png' },
  { code: 'me', name: 'Crnogorski', flag: 'https://flagcdn.com/w40/me.png' },
];

const currentLocale = computed(() => locale.value);

const currentLanguageName = computed(() => {
  const lang = languages.find(l => l.code === locale.value);
  return lang ? lang.name : 'Language';
});

const currentFlag = computed(() => {
  const lang = languages.find(l => l.code === locale.value);
  return lang ? lang.flag : '';
});

const changeLanguage = (code) => {
  locale.value = code;
  localStorage.setItem('pagaime_lang', code);
  // Optional: For Arabic, you might want to handle RTL
  document.dir = code === 'ar' ? 'rtl' : 'ltr';
};
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.turkish-flag-style {
  /* add any specific style for turkish flag if needed as per user request */
}
.language-btn {
  text-transform: none;
  padding: 0 4px !important;
}
.v-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style>
